import React,{useContext, useEffect, useState} from 'react';
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Modal } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

import { toAbsoluteUrl } from "../../../helpers/CommonFunction";
import AppContext from '../../../../app/routing/AuthContext';

import { getLocalStrogeValue } from '../../../../app/component/common/Helper';
import ValidationMessage from '../../../../app/component/common/ValidationMessage';
import AlertMessage from '../../../../app/component/common/AlertMessage';


const HeaderUserMenu = () => {
    const api_base_url = process.env.REACT_APP_API_URL;
    const agentInfo = JSON.parse(localStorage.getItem('agentInfo'));
    const authCtx = useContext( AppContext );
    const loginUserType = localStorage.getItem('type');

    const logoutHandler = async() => {
        if(localStorage.getItem('type') === "E") {
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : localStorage.getItem('agenttoken')
                }
            };
            await axios.post(`${api_base_url}api/agent-logout`, { agent_id: agentInfo.unique_id}, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    authCtx.logout({
                        type: localStorage.getItem('type')
                    });
                }
            })
            .catch((error) => {
                console.error(error);
            })
        } else {
            authCtx.logout({
                type: localStorage.getItem('type')
            });
        }
    }

    const loginInfo = localStorage.getItem('agentInfo');
    const loginType = localStorage.getItem('type');
    const devLoginInfo = localStorage.getItem('developerinfo');

    const [ headerDetails, setHeaderDetails ] = useState({
        user_name: '',
        email : ''
    })
    useEffect(() => {
        if(loginType === 'A'){
            setHeaderDetails({
                user_name: localStorage.getItem('business_name'),
                email: localStorage.getItem('business_email')
            })
        }
        else if(loginType === 'E'){
            const jpLoginInfo = JSON.parse(loginInfo)
            setHeaderDetails({
                user_name: jpLoginInfo.agent_name,
                email: jpLoginInfo.agent_email
            })
        }
        else if(loginType === 'D'){
            const jpDevLoginInfo = JSON.parse(devLoginInfo);
            setHeaderDetails({
                user_name: jpDevLoginInfo.user_full_name,
                email: jpDevLoginInfo.user_email
            });
        }
    },[loginInfo])
    // This is change password code
    const [changePasswordModal, setChangePasswordModal] = useState(false);

    const [passwordChangeForm, setPasswordChangeForm] = useState({
        old_password: "",
        new_password: "",
        confirm_password: "",
    });

    const [ formErorr, setFormError ] = useState({});
    const [ oldPassShow, setOldPassShow ] = useState(false);
    const [ newPassShow, setNewPassShow ] = useState(false);
    const [ conPassShow, setConPassShow ] = useState(false);
    const [ changeResponse, setChangeResponse ] = useState({
        res_type : '',
        title : '',
        sub_title : '',
    });

    const onCloseHandler = () => {
        setPasswordChangeForm((prevData) => ({
            ...prevData,
            old_password: '',
            new_password: '',
            confirm_password: ''
        }));
        setChangePasswordModal(false);
    }
    const validateField = (name, value) => {
        let error = "";
        if (name === "old_password") {
            if (!value) {
                error = "Old Password is required";
            } 
        }
        if(name === 'new_password') {
            if (!value) {
                error = "New Password is required";
            }
        }
        if(name === 'confirm_password') {
            if (!value) {
                error = "Confirm Password is required";
            }
        }
        return error;
    };
    const inputChangeHandler = (event) => {
        const { name, value } = event.target;
        const fieldError = validateField(name, value);
        setFormError((prevErrors) => ({
            ...prevErrors,
            [name]: fieldError,
        }));
        setPasswordChangeForm((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }
    const toggleOldPasswordVisibility = () => {
        setOldPassShow(!oldPassShow);
    }
    const toggleNewPasswordVisibility = () => {
        setNewPassShow(!newPassShow);
    }
    const toggleConPasswordVisibility = () => {
        setConPassShow(!conPassShow);
    }
    const onSubmitHandler = async (e) => {

        // console.log('ok test')
        // return

        e.preventDefault();
        const newErrors = {};
        for (const key in passwordChangeForm) {
            newErrors[key] = validateField(key, passwordChangeForm[key]);
        }
        setFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {

            // const old_password = localStorage.getItem("system_password");
            // if(old_password) {
            //     if(passwordChangeForm.old_password != old_password) {
            //         setFormError((prevErrors) => ({
            //             ...prevErrors,
            //             ['old_password']: "Old password are not match with current password",
            //         }));
            //         return;
            //     }
            // }

            if((passwordChangeForm.new_password === passwordChangeForm.confirm_password)) {

                let apiToken = '';
                if(loginUserType === 'A') {
                    apiToken = localStorage.getItem('token')
                } else if(loginUserType === 'D') {
                    apiToken = localStorage.getItem('developertoken')
                } else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }


                const api_headers = {
                    headers: { 
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "x-access-token" : apiToken
                    }
                };
                await axios.post(`${api_base_url}api/new-password-generate`, passwordChangeForm, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        setChangeResponse({
                            res_type : 'success',
                            title : 'Verified',
                            sub_title : "Password successfully changed",
                        });
                        setPasswordChangeForm((prevData) => ({
                            ...prevData,
                            old_password: '',
                            new_password: '',
                            confirm_password: ''
                        }));
                        setTimeout(() => {
                            setChangePasswordModal(false)
                        }, 1500);
                    } else if(res.data.status === 'error') {
                        setChangeResponse({
                            res_type : 'danger',
                            title : 'Faild',
                            sub_title : res.data.message,
                        });
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
            } else {
                setFormError((prevErrors) => ({
                    ...prevErrors,
                    ['confirm_password']: "Confirm password are not match with new password",
                }));
            }
        }
    }
    return (
        <>
        <div
            className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
            data-sai-menu='true'
        >
            <div className='menu-item px-3'>
                <div className='menu-content d-flex align-items-center px-3'>
                    <div className='symbol symbol-50px me-5'>
                        <img alt='Logo' src={toAbsoluteUrl('media/avatars/300-1.jpg')} />
                    </div>
                    <div className='d-flex flex-column'>
                        <div className='fw-bolder d-flex align-items-center fs-5'>
                            { headerDetails.user_name }
                            {
                                loginType === 'SA' &&
                                <span className="badge badge-light-success fw-bold fs-8 px-2 py-1 ms-2">
                                    System Admin
                                </span>
                            }
                        </div>
                        <div className='fw-bold text-muted fs-7 mt-1'>
                            { headerDetails.email }
                        </div>
                    </div>
                </div>
            </div>
            <div className='separator my-2'></div>
            {
                loginType === 'A' &&
                <div className='menu-item px-5'>
                    <Link to={'/settings/business-setup'} className='menu-link px-5'>
                        Business Profile 
                    </Link>
                </div>
            }
            {
                loginType === 'D' &&
                <div className='menu-item px-5'>
                    <Link to={'/profile'} className='menu-link px-5'>
                        Profile 
                    </Link>
                </div>
            } 
            <div className='menu-item px-5'>
                <a className='menu-link px-5' onClick={()=>setChangePasswordModal(true)}>
                    Change Password
                </a>
            </div>
            <div className='menu-item px-5'>
                <a className='menu-link px-5' onClick={logoutHandler}>
                    Sign Out
                </a>
            </div>
        </div>

        <Modal
            open={changePasswordModal}
            title={null}
            footer={null}
        >
            <div className='row overflow-y-auto'>
                <div className='col-md-12'>
                    <div className="text-center mb-5">
                        <h1 className="text-gray-800 mb-2 fs-2x">
                            Change Password
                        </h1>
                    </div>
                </div>

                {changeResponse.res_type != '' &&
                    <div className='col-md-12'>
                        <AlertMessage
                            type = {changeResponse.res_type}
                            title = {changeResponse.title}
                            sub_title = {changeResponse.sub_title}
                            border_type='dashed'
                        />
                    </div>
                }
               
                <div className='col-md-12'>
                    <div className='row'>
                        <div className="col-md-12">
                            <div className="fv-row mb-8">
                                <label className="d-flex align-items-center fs-6 fw-semibold form-label mb-2">
                                    <span className="required">Old Password</span>
                                </label>
                                <div className="position-relative">
                                    <input 
                                        className={`form-control bg-transparent ${!oldPassShow ? 'inp-secure' : ''} ${formErorr.old_password ? 'is-invalid' : ''}`}
                                        type="text" 
                                        placeholder="Old Password" 
                                        name="old_password" 
                                        autoComplete="off" 
                                        style={{ height: '50px' }}
                                        onChange={inputChangeHandler}
                                        value={passwordChangeForm.old_password}
                                    />
                                    {passwordChangeForm.old_password && <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
                                        { !oldPassShow && 
                                            <FontAwesomeIcon 
                                                icon={faEye} 
                                                className='fs-4 cursor-pointer text-gray-500'
                                                onClick={ toggleOldPasswordVisibility }
                                            />
                                        }
                                        { oldPassShow && 
                                            <FontAwesomeIcon 
                                                icon={faEyeSlash} 
                                                className='fs-4 cursor-pointer text-gray-500'
                                                onClick={ toggleOldPasswordVisibility }
                                            />
                                        }
                                    </span>}
                                </div>
                                {formErorr.old_password && <ValidationMessage className='text-danger' message ={formErorr.old_password}/>}
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className="fv-row mb-8">
                                <label className="d-flex align-items-center fs-6 fw-semibold form-label mb-2">
                                    <span className="required">
                                        New Password
                                    </span>
                                </label>
                                <div className="position-relative">
                                    <input 
                                        className={`form-control bg-transparent ${!newPassShow ? 'inp-secure' : ''} ${formErorr.new_password ? 'is-invalid' : ''}`}
                                        type="text" 
                                        placeholder="New Password" 
                                        name="new_password" 
                                        autoComplete="off" 
                                        style={{ height: '50px' }}
                                        onChange={inputChangeHandler}
                                        value={passwordChangeForm.new_password}
                                    />
                                    {passwordChangeForm.new_password && <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
                                        { !newPassShow && 
                                            <FontAwesomeIcon 
                                                icon={faEye} 
                                                className='fs-4 cursor-pointer text-gray-500'
                                                onClick={ toggleNewPasswordVisibility }
                                            />
                                        }
                                        { newPassShow && 
                                            <FontAwesomeIcon 
                                                icon={faEyeSlash} 
                                                className='fs-4 cursor-pointer text-gray-500'
                                                onClick={ toggleNewPasswordVisibility }
                                            />
                                        }
                                    </span>}
                                </div>
                                {formErorr.new_password && <ValidationMessage className='text-danger' message ={formErorr.new_password}/>}
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className="fv-row mb-8">
                                <label className="d-flex align-items-center fs-6 fw-semibold form-label mb-2">
                                    <span className="required">
                                        New Confirm Password
                                    </span>
                                </label>
                                <div className="position-relative">
                                    <input 
                                        className={`form-control bg-transparent ${!conPassShow ? 'inp-secure' : ''} ${formErorr.confirm_password ? 'is-invalid' : ''}`}
                                        type="text" 
                                        placeholder="New Password" 
                                        name="confirm_password" 
                                        autoComplete="off" 
                                        style={{ height: '50px' }}
                                        onChange={inputChangeHandler}
                                        value={passwordChangeForm.confirm_password}
                                    />
                                    {passwordChangeForm.confirm_password && <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
                                        { !conPassShow && 
                                            <FontAwesomeIcon 
                                                icon={faEye} 
                                                className='fs-4 cursor-pointer text-gray-500'
                                                onClick={ toggleConPasswordVisibility }
                                            />
                                        }
                                        { conPassShow && 
                                            <FontAwesomeIcon 
                                                icon={faEyeSlash} 
                                                className='fs-4 cursor-pointer text-gray-500'
                                                onClick={ toggleConPasswordVisibility }
                                            />
                                        }
                                    </span>}
                                </div>
                                {formErorr.confirm_password && <ValidationMessage className='text-danger' message ={formErorr.confirm_password}/>}
                            </div>
                        </div>
                        
                        <div className='col-md-12 text-end'>
                            <button 
                                className="btn btn-dark me-3"
                                onClick={onCloseHandler}
                            >
                                Close
                            </button>
                            <button 
                                className="btn btn-primary"
                                onClick={onSubmitHandler}
                            >
                                Change
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
        </>
    )
}

export default HeaderUserMenu;